/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDto } from '../../models/document-dto';

export interface FixDocumentControllerFindByTicketId$Params {
  ticketId: string;
}

export function fixDocumentControllerFindByTicketId(http: HttpClient, rootUrl: string, params: FixDocumentControllerFindByTicketId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentDto>>> {
  const rb = new RequestBuilder(rootUrl, fixDocumentControllerFindByTicketId.PATH, 'get');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentDto>>;
    })
  );
}

fixDocumentControllerFindByTicketId.PATH = '/api/fix-document';
